<template>
  <div class="approved-devices-wrapper animated fadeIn">
    <div v-if="!devices" class="text-center py-5">
      <b-spinner label="Loading..." variant="primary"></b-spinner>
      <p class="text-muted mt-2">Loading authorized devices...</p>
    </div>

    <b-card v-else>
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
            <span><i class="fa fa-mobile-phone"></i> <strong>Authorized Devices</strong></span>
            <b-badge variant="success">{{ devices.length }}</b-badge>
        </div>
      </template>

      <b-table
        hover
        responsive
        :items="devices"
        :fields="fields"
        show-empty
        empty-text="No authorized devices found."
        class="mb-0"
      >
        <!-- MAC -->
        <template #cell(mac)="data">
            <span class="text-monospace font-weight-bold">{{ data.value }}</span>
            <b-button 
                size="sm" 
                variant="outline-primary" 
                class="ml-2 py-0 px-1" 
                @click="checkShared(data.value)"
                title="Check for other accounts with this MAC"
            >
                <i class="fa fa-search small"></i>
            </b-button>
        </template>

        <!-- OS -->
        <template #cell(os)="data">
            <span class="font-weight-bold">{{ data.value }}</span>
        </template>

        <!-- Date -->
        <template #cell(date)="data">
            <span>{{ data.value | formatDate }}</span>
        </template>

        <!-- Actions -->
        <template #cell(actions)="data">
            <b-button
                v-if="hasPermission(ApprovedDevicesDelete)"
                size="sm"
                variant="outline-danger"
                @click="deleteDevice(data.item.mac)"
                title="Delete this authorized device"
            >
                <i class="fa fa-trash"></i>
            </b-button>
        </template>

      </b-table>
    </b-card>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import iziToast from 'izitoast'

export default {
  name: 'ApprovedDevicesView',
  props: {
    username: { type: String, required: true },
    server: { type: String, required: true }
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
        devices: 'approvedDevices',
        sharedIPs: 'sharedIPs'
    }),
    fields() {
        let f = [
            { key: 'mac', label: 'MAC Address', sortable: true },
            { key: 'os', label: 'Operating System / Device', sortable: true },
            { key: 'date', label: 'Authorized On', sortable: true }
        ];
        if (this.hasPermission(this.ApprovedDevicesDelete)) {
            f.push({ key: 'actions', label: 'Actions', class: 'text-right' });
        }
        return f;
    }
  },
  watch: {
    username: 'fetchData'
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
        if (this.username) {
             this.$store.commit('setApprovedDevices', null) 
             this.emit('getApprovedDevices', {
                username: this.username, 
                server: this.server
             })
        }
    },
    checkShared(mac) {
        this.$store.commit('setSharedIPs', null);
        
        this.emit('getSharedMACs', {
            mac: mac,
            server: this.server
        });
        
        this.$root.$emit('show-shared-modal', {
            title: `Shared MAC Analysis: ${mac}`,
            server: this.server
        });
    },
    deleteDevice(mac) {
        iziToast.question({
            timeout: 20000,
            close: false,
            overlay: true,
            displayMode: 'once',
            id: 'question',
            zindex: 999,
            title: 'Delete Device',
            message: `Are you sure you want to delete the authorized device with MAC: <b>${mac}</b>?`,
            position: 'center',
            buttons: [
                ['<button><b>YES</b></button>', (instance, toast) => {
                    instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
                    this.emit('deleteApprovedDevice', {
                        username: this.username,
                        mac: mac
                    })
                    // Refresh data after a short delay to allow backend to process
                    setTimeout(() => {
                        this.fetchData();
                    }, 500);
                }, true],
                ['<button>NO</button>', function (instance, toast) {
                    instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
                }],
            ]
        });
    }
  },
  filters: {
      formatDate(val) {
          if (!val || val.startsWith('0001') || val.startsWith('0000')) return '-'; 
          return moment(val).format('YYYY-MM-DD HH:mm:ss');
      }
  }
}
</script>

<style scoped>
.approved-devices-wrapper {
    min-height: 400px;
}
</style>
